__turbopack_context__.v({
  "hasLeftIcon": "Input-module__lP9mNG__hasLeftIcon",
  "hasLeftLabelIcon": "Input-module__lP9mNG__hasLeftLabelIcon",
  "hasRightIcon": "Input-module__lP9mNG__hasRightIcon",
  "input": "Input-module__lP9mNG__input",
  "inputFieldWrapper": "Input-module__lP9mNG__inputFieldWrapper",
  "leftLabelIcon": "Input-module__lP9mNG__leftLabelIcon",
  "small": "Input-module__lP9mNG__small",
});
